import React, { Component } from 'react';
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import OurServicesInfo from './OurServicesInfo';
class OurServices extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  window.menu_selection('/services');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Service Industry"/>
          <OurServicesInfo/>
          <Footer />
        </div>
    );
  }
}

export default OurServices;
